module.exports = __webpack_public_path__ + "img/bepreisung_5_1.43320e49.png";